import React, { useContext, useRef, useEffect } from 'react';

import PresentationContext from '../PresentationContext';
import TargetContext from './TargetContext';
import { exposeToClipboard, removeClipboardListener } from '../utils/clipboard';
import { mgdL } from '../utils/consts';
import './Dashboard.css';


function TiRBar({ ranges, showHandles = true, title, viewBox = '-12 -15 39 138' }) {
  const {
    formatGlucoseValue,
  } = useContext(PresentationContext);
  const { targets } = useContext(TargetContext);
  const copyRef = useRef(null);

  useEffect(() => {
    let node;
    if (copyRef.current) {
      node = copyRef.current;
      exposeToClipboard(node);
    }
    return () => {
      if (node) {
        removeClipboardListener(node);
      }
    }
  }, [copyRef]);

  return (
    <svg
      className="tir copyToClipboard"
      ref={copyRef}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMin slice"
      shapeRendering="auto"
    >
      <title>
        {title}
      </title>
      <g>
        <g transform="translate(-2,0)">
          <text
            y={Math.max(4.5, Math.min(84, ranges.high.y))}
            dy="0.35em"
          >
            {formatGlucoseValue({ value: 250, unit: mgdL })}
          </text>
          <text
            y={Math.max(9, Math.min(88.5, (ranges.hypo.y - 4.5), ranges.low.y))}
            dy="0.35em"
          >
            {formatGlucoseValue({ value: targets.top, unit: mgdL })}
          </text>
          <text
            y={Math.max(13.5, Math.min(94, (ranges.min.y - 4.5), ranges.hypo.y))}
            dy="0.35em"
          >
            {formatGlucoseValue({ value: targets.bottom, unit: mgdL })}
          </text>
          <text
            y={ranges.min.y}
            dy="0.35em"
          >
            {formatGlucoseValue({ value: 54, unit: mgdL })}
          </text>
        </g>
        <g>
          <rect className="high" y={ranges.high.y} width="23" height={ranges.high.value} />
        </g>
        <rect className="target" y={ranges.low.y} width="23" height={ranges.low.value} />
        <rect
          className="low"
          y={ranges.hypo.y}
          width="23"
          height={ranges.hypo.value}
        />
        <g>
          {showHandles
          ? (
            <path className="guideline" d="M 12 0 a 2 2 0 0 1 2 -2 h 9" />
          )
          : undefined
          }
          <path
            className="very-high"
            d={`M 0 ${ranges.hyper.value
              } v ${2 - ranges.hyper.value
              } a 2 2 0 0 1 2 -2 h 19 a 2 2 1 0 1 2 2 v ${ranges.hyper.value - 2
              } Z`}
          />
        </g>
        <g>
          <path
            className="very-low"
            d={`M 0 ${ranges.min.y
              } v ${ranges.min.value - 2
              } a 2 2 1 0 0 2 2 h 19 a 2 2 0 0 0 2 -2 v ${2 - ranges.min.value
              } Z`}
          />
          {showHandles
          ? (
            <path className="guideline" d="M 12 100 a 2 2 1 0 0 2 2 h 9" />
          )
          : undefined
          }
  
        </g>
      </g>
    </svg>
  );
}

export default TiRBar;
